export default __webpack_public_path__ + "8c2b11477353e3b4095ab29c3e602894.png";